import { AppRegistry } from 'react-native'

import { App } from './App'
import './index.css'

AppRegistry.registerComponent('trivie', () => App)
AppRegistry.runApplication('trivie', {
  rootTag: document.getElementById('root'),
})
